<template>
  <div id="in-page">
    <div class="module-search">
      <el-input v-model="searchContent" placeholder="请输入设备名称、IMEI、MAC等关键字进行搜索" class="input-with-select">
        <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
      </el-input>

      <el-button
        :disabled="!isMore"
        title="请先选择设备"
        class="search-btn"
        type="primary"
        icon="el-icon-plus"
        @click="handleMoreBtn"
      >
        批量修改分配
      </el-button>
    </div>

    <div class="table-box">
      <el-table
        ref="multipleTable"
        v-loading="tableLoading"
        :data="tableList"
        :show-overflow-tooltip="true"
        class="module-main"
        style="width: 100%"
        header-row-class-name="table-header"
        row-class-name="table-row"
        border
        @selection-change="handleSelection"
      >
        <el-table-column type="selection" :selectable="({installTime}) => !installTime"></el-table-column>
        <el-table-column prop="outTime" label="出库时间" align="center" width="160" />
        <el-table-column show-overflow-tooltip prop="code" label="设备编码" align="center" />
        <el-table-column show-overflow-tooltip prop="name" label="设备名称" align="center" />
        <el-table-column show-overflow-tooltip prop="groupName" label="产品型号" align="center" />
        <!-- <el-table-column prop="brand" label="品牌" align="center" /> -->
        <!-- <el-table-column prop="guid" label="GUID" align="center" /> -->
        <el-table-column show-overflow-tooltip prop="imei" label="IMEI" align="center" />
        <el-table-column show-overflow-tooltip prop="mac" label="MAC" align="center" />
        <el-table-column show-overflow-tooltip prop="allotCompany" label="分配公司" align="center" />
        <!-- <el-table-column label="分配状态" align="center" width="80">
          <template slot-scope="scope">
            <span :class="scope.row.allotCompanyId ? 'green' : 'red'">
              {{ scope.row.allotCompanyId ? '已分配' : '未分配' }}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column label="安装状态" align="center" width="80">
          <template slot-scope="scope">
            <span :class="scope.row.installTime ? 'green' : 'red'">
              {{ scope.row.installTime ? '已安装' : '未安装' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="right" width="160">
          <template slot-scope="scope">
            <span v-if="!scope.row.installTime" class="table-detail" @click="handleDistribution(scope.row)">修改分配</span>
            <span class="table-detail" @click="handleClick(scope.row.id)">详情</span>
            <span class="table-delete" @click="handleDelete(scope.row.id)">删除</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :current-page="pagination.pageIndex"
        background
        class="pagination"
        layout="prev, pager, next"
        @current-change="changePageData"
      />
    </div>

    <el-dialog
      :visible.sync="addUserDialogVisibility"
      custom-class="add-user-dialog"
      title="设备详情"
      width="960px"
      @closed="handleAddUserDialogClosed"
    >
      <div class="input-info">
        <span class="title"><span>*</span>出库时间:</span>
        <el-input v-model="addUserDialogData.outTime" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>设备编码:</span>
        <el-input v-model="addUserDialogData.code" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>产品型号:</span>
        <el-input v-model="addUserDialogData.groupName" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>IMEI:</span>
        <el-input v-model="addUserDialogData.imei" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>设备名称:</span>
        <el-input v-model="addUserDialogData.name" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>GUID:</span>
        <el-input v-model="addUserDialogData.guid" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>品牌:</span>
        <el-input v-model="addUserDialogData.brand" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>MAC:</span>
        <el-input v-model="addUserDialogData.mac" disabled placeholder="请输入内容" />
      </div>
      <div v-if="addUserDialogData.allotCompanyId" class="input-info">
        <span class="title"><span>*</span>分配公司:</span>
        <el-input v-model="addUserDialogData.allotCompany" disabled placeholder="请输入内容" />
      </div>
      <div v-else class="input-info">
        <span class="title"><span>*</span>分配状态:</span>
        <el-input value="未分配" disabled placeholder="请输入内容" />
      </div>
      <div class="input-infos">
        <span class="title">备注:</span>
        <el-input
          v-model="addUserDialogData.remarks"
          class="remark-box"
          type="textarea"
          placeholder="请输入内容"
          maxlength="30"
          show-word-limit
          disabled
        >
        </el-input>
      </div>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button class="certain-btn" type="primary" @click='handleSureAdd'>{{text}}</el-button>
      </span> -->
    </el-dialog>

    <!-- 分配 -->
    <el-dialog
      :visible.sync="distributDialogVisibility"
      custom-class="add-user-dialog"
      title="分配"
      width="640px"
      @closed="handleDistributDialogClosed"
    >
      <div class="input-info">
        分配公司:
        <base-cascader
          v-model="allotCompanyId"
          clearable
          expand-trigger="hover"
          :show-all-levels="false"
          placeholder="请选择"
          :props="defaultProps"
          :options="deptDict"
          change-on-select
          @change="handleChange"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="certain-btn" type="primary" @click="handleSuredistribut">分配</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import BaseCascader from '@/components/BaseCascader'
import { formatDateTime } from '@/utils/objectUtil'

export default {
  name: 'InPage',
  components: {
    BaseCascader,
  },
  data () {
    return {
      tableLoading: true,
      searchContent: '',
      statusList: [
        { value: true, code: '启用' },
        { value: false, code: '禁用' },
      ],
      // 列表样式
      tableList: [],
      // 分页数据
      pagination: {
        // 一共多少页
        pageCount: 1,
        // 第几页
        pageIndex: 1,
        // 一页显示多少个
        pageSize: 10,
        // 总个数
        total: 0,
      },
      // 添加弹窗数据
      addUserDialogData: {
        outTime: '',
        code: '',
        name: '',
        brand: '',
        guid: '',
        imei: '',
        mac: '',
        remarks: '',
        online: 0,
        allotCompany: '',
        allotCompanyId: '',
        groupId: '',
        groupName: '',
      },
      addUserDialogVisibility: false,
      distributDialogVisibility: false,
      defaultProps: {
        children: 'childs',
        label: 'name',
        value: 'id',
      },
      text: '添加',
      id: '',
      allotCompanyId: '',
      allotCompany: '',
      isMore: false,
      ids: '', // 批量分配的id
      deptDict: [], // 单位字典
    }
  },
  computed: {
    // ...mapGetters(['getDicByType']),
    // deptDict () {
    //   return this.getDicByType('Dept')
    // },
  },
  created () {
    let { pagination: { pageIndex, pageSize } } = this
    this.getListReq({ pageIndex, pageSize })
    this.getDicByType()
  },
  methods: {
    /**
     * @description: 获取单位字典
     * @return       {undefind} [undefind]
     */
    getDicByType () {
      this.$http.post('/api/json/getDict', { dictType: 'Dept' }).then(res => {
        if (res.code === 'success') {
          let { list } = res.data

          let listTemp = list && list.map(({ childs, name, id }) => ({ childs: null, name, id }))

          this.deptDict = listTemp
        }
      })
    },
    /**
     * @description: 改变选择状态时的触发函数
     * @param        {Array} selection 表示选中的设备信息列表
     * @return       {undefint}   [undefint]
     */
    handleSelection (selection) {
      this.id = ''

      this.isMore = false

      if (!selection.length) return

      this.isMore = true

      this.ids = selection.reduce((total, item) => ([...total, item.id]), []).join(',')
    },
    /**
     * @description: 点击批量分配
     * @param        {[type]} e [description]
     * @return       {[type]}   [description]
     */
    handleMoreBtn () {
      this.distributDialogVisibility = true
      // console.log(this.deptDict)
      this.allotCompanyId = ''
      this.allotCompany = ''
    },
    /**
     * @description: 选择分配公司
     * @param        {[type]} e [description]
     * @return       {[type]}   [description]
     */
    handleChange (e) {
      let temp = this.deptDict.filter(({ id }) => id === e[0])
      if (temp.length) this.allotCompany = temp[0].name
    },
    getListReq (params) {
      this.tableLoading = true
      this.$http.get('/api/device-info/list-inout', { ...params, type: 1 }).then(res => {
        this.tableLoading = false
        if (res.code === 'success') {
          let { list, pageCount, total } = res.data
          let listTemp = list.map(val => {
            val.outTime = formatDateTime(new Date(val.outTime), 'yyyy-MM-dd HH:mm:ss')
            return val
          })
          this.tableList = listTemp
          this.pagination.pageCount = pageCount
          this.pagination.total = total
        }
      })
    },
    handleClick (id) {
      let loadObj = this.$loading({ target: document.querySelector('.add-user-dialog') })

      this.$http.get('/api/device-info/show', { id }).then(res => {
        loadObj.close()
        if (res.code === 'success') {
          let { code, name, brand, guid, imei, mac, remarks, id, outTime, allotCompany, allotCompanyId, groupId, groupName } = res.data
          outTime = formatDateTime(new Date(outTime), 'yyyy-MM-dd HH:mm:ss')
          this.addUserDialogData = { code, name, brand, guid, imei, mac, remarks, id, outTime, allotCompany, allotCompanyId, groupId, groupName }
        }
      })
      this.addUserDialogVisibility = true
    },
    handleDelete (ids) {
      this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
      })
        .then(async () => {
          this.$http.post('/api/device-info/del', { ids }).then(res => {
            if (res.code === 'success') {
              this.$message({ message: '删除成功', type: 'success' })

              this.getListReq({ pageIndex: this.pagination.pageIndex, pageSize: this.pagination.pageSize })
            } else {
              this.$message.error(`删除失败：${res.msg}`)
            }
          })
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消' })
        })
    },
    handleAddUserDialogClosed () {
      this.addUserDialogVisibility = false
    },
    handleDistributDialogClosed () {
      this.distributDialogVisibility = false
    },
    changePageData (e) {
      let { pagination: { pageSize }, searchContent } = this

      this.pagination.pageIndex = e

      this.getListReq({ pageIndex: e, pageSize, searchContent })
    },
    handleSearch () {
      let { pagination: { pageIndex, pageSize }, searchContent } = this

      this.getListReq({ pageIndex, pageSize, searchContent })
    },
    handleSureAdd () {
      let params = this.getParams()

      if (!params) return

      this.$http.post('/api/device-info/save', params).then(res => {
        if (res.code === 'success') {
          this.$message({ message: `${this.text}成功`, type: 'success' })
          this.addUserDialogVisibility = false
          this.getListReq({ pageIndex: 1, pageSize: 10 })
        } else {
          this.$message.error(`添加失败, ${res.msg}`)
        }
      })
    },
    getParams () {
      let { code, name, brand, guid, imei, mac, groupId } = this.addUserDialogData

      if (!(code && name && brand && guid && imei && mac && groupId)) {
        this.$message({ message: '警告！请检查带星号是否填写', type: 'warning' })
        return false
      }

      if (this.id) this.addUserDialogData.id = this.id

      return this.addUserDialogData
    },
    // 分配操作
    handleDistribution (row) {
      let { id, allotCompanyId, allotCompany } = row
      this.id = id
      this.ids = ''
      this.allotCompanyId = [allotCompanyId]
      this.allotCompany = allotCompany
      this.distributDialogVisibility = true
      this.$refs.multipleTable.clearSelection()
    },
    // 添加分配-单个
    handleSuredistribut () {
      let url = 'api/device-info/allot'
      let { allotCompanyId, allotCompany, id, ids } = this

      let params = {
        allotCompanyId: allotCompanyId[0],
        allotCompany,
      }
      if (id) params.id = id
      if (ids) {
        params.ids = ids
        url = '/api/device-info/allots'
      }
      this.$http.post(url, params).then(res => {
        if (res.code === 'success') {
          this.distributDialogVisibility = false

          this.$message({ message: '分配成功', type: 'success' })

          this.getListReq({ pageIndex: this.pagination.pageIndex, pageSize: 10 })
        } else {
          this.$message.error(`分配失败，${res.msg}`)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
#in-page {
  // padding-top: 20px;
  background-color: #fff;
  // border: 1px solid #EBEEF0;
  >div {
    width: 95%;
    margin: 0 auto;
  }
  .module-search {
    margin-top: 20px;
    .input-with-select {
      width: 500px;
    }
    span {
      margin-right: 5px;
      font-size: 14px;
      color: #666;
    }

    /deep/ .el-select {
      width: 90px;
    }

    /deep/ .el-input {
      input {
        padding-right: 0px;

        &::-webkit-input-placeholder {
          font-size: 14px;
        }
      }
    }

    .status-select {
      width: 149px;

      /deep/ .el-input__inner {
        height: 36px;
        border-radius: 2px;
        font-size: 14px;
        color: #333;
      }
    }

    .content-input {
      width: 280px;
      margin-left: 50px;

      /deep/ .el-input-group__prepend {
        border-radius: 2px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;

        .el-input__inner {
          width: 80px;
          height: 36px;
          border-radius: 2px !important;
        }
      }

      /deep/ .el-input__inner:nth-child(2) {
        width: 200px;
        height: 36px;
        border-radius: 2px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }

    /deep/ .search-btn {
      padding: 10px 25px;
      border-radius: 3px;
      // margin-left: 50px;
      border: 1px solid #5294d6;
      color: #5294d6;
      background: #fff;
      float: right;

      &:hover {
        background-color: fade(#5294d6, 10);
        color: #5294d6;
      }
    }
    .add-btn {
      float: right;
    }
  }

  .table-box {
    margin-top: 20px;
    .module-main {
      .delete-tag {
        color: #f06366;
        text-decoration: underline;
        margin-left: 3px;
        cursor: pointer;
      }

      .green {
        color: #4dd292;
      }

      .red {
        color: #f06366;
      }

      .blue-btn {
        width: 72px;
        background-color: #5294d6;
        // margin-left: 5px;

        &:hover {
          background-color: fade(#5294d6, 85);
        }
      }

      .red-btn {
        background-color: #f06366;
        margin-left: 5px;

        &:hover {
          background-color: fade(#f06366, 80);
        }
      }

      .look-details {
        color: #5294d6;
        text-decoration: underline;
        cursor: pointer;
      }

      /deep/ .table-header {
        color: #333;
        font-size: 14px;
        font-weight: bold;

        th {
          // height: 40px !important;
          // padding: 0px;
          text-align: center !important;
          line-height: 25px;
          background-color: #e9f0fa;
        }
      }

      /deep/ .table-row {
        color: #333;
        font-size: 14px;

        .numbering {
          color: #5294d6;
          text-decoration: underline;
          cursor: pointer;
        }

        td {
          padding: 12px 0;
        }
      }
    }
    .table-delete {
      color: #F56C6C;
      cursor: pointer;
    }
    .table-detail {
      color: #409EFF;
      margin-right: 10px;
      cursor: pointer;
    }
    .pagination {
      padding: 31px 0;
      height: 32px;
      text-align: center;
      font-weight: normal;

      /deep/ .number {
        background-color: #fff;
        border: 1px solid #e1e1e1;
        padding: 2px 5px;
        height: 32px;
        min-width: 32px;
      }

      /deep/ .active {
        border: none;
        background-color: #4078dd;
      }

      /deep/ .btn-prev {
        width: 32px;
        height: 32px;
      }

      /deep/ .btn-next {
        width: 32px;
        height: 32px;
      }

      /deep/ .more {
        width: 32px;
        height: 32px;
        line-height: 35px;
      }
    }
  }

  /deep/ .add-user-dialog,
  /deep/ .modify-user-data-dialog {
    .el-dialog__header {
      height: 40px;
      padding: 0px;
      line-height: 40px;
      text-indent: 20px;
      background-color: #214f88;
    }

    .el-dialog__headerbtn {
      margin-top: -6px;
    }

    .el-dialog__header .el-dialog__title {
      font-size: 16px;
      color: #fff;
    }

    .el-dialog__body {
      padding: 30px 20px 30px 55px;
      // min-height: 485px;
    }

    .input-info {
      display: inline-block;
      margin-bottom: 30px;
      width: 400px;
      .title {
        text-align: right;
        display: inline-block;
        width: 90px;
        // margin-right: 14px;

        & > span {
          color: red;
          margin-right: 3px;
        }
      }

      .el-input {
        width: 240px;
        margin-left: 10px;

        input {
          height: 36px;
        }
      }

      .el-cascader {
        .el-cascader__label {
          text-indent: 13px;
        }
      }

      &.long {
        box-sizing: border-box;
        clear: both;
        width: 100%;
        margin-left: 0px;
        padding-right: 85px;

        .el-input {
          width: 720px;
        }
      }

      .info-content {
        color: #c4c3c3;
        font-size: 12px;
      }

      .el-select__tags {
        text-align: left;
        padding-left: 15px;
      }
    }

    .input-infos {
      .title {
        text-align: right;
        display: inline-block;
        width: 90px;
        margin-right: 10px;
      }
      .remark-box {
        width: 640px;
        vertical-align: top;
      }
    }

    .radio-info {
      float: left;
      margin-bottom: 13px;
      height: 36px;
      line-height: 36px;
      width: 320px;

      &:nth-child(3) {
        margin-left: 33px;
      }

      &:nth-child(4) {
        margin-left: 160px;
      }

      .el-radio-group {
        margin-left: 10px;
      }
    }
  }
}
</style>
